import PropTypes from 'prop-types';

import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';

import CheckMark from '../icons/CheckMark';

import Colors from '../utils/colors';

import styles from './IncludedBadge.module.scss';

const IncludedBadge = ({
  includedCopy = null,
  valueSubtitle = null,
  className = ''
}) => {
  const includedClasses = classNames(styles['included-badge'], className);

  return (
    <div className={includedClasses}>
      <CheckMark color={Colors.success} />
      {includedCopy || trans('listing.bills.is-included')}
      {valueSubtitle && (
        <div className={styles['included-badge__subtitle']}>
          {valueSubtitle}
        </div>
      )}
    </div>
  );
};

IncludedBadge.propTypes = {
  includedCopy: PropTypes.string,
  valueSubtitle: PropTypes.string,
  className: PropTypes.string
};

export default IncludedBadge;
